import React from 'react';

import * as S from './styles';

const PremiumBanner = ({
  label,
  brandName,
  banner,
}: {
  label: string;
  brandName: string;
  banner?: string | null;
}) => (
  <S.Block>
    <S.Label>{label}</S.Label>
    {banner && <img alt={brandName} src={banner} />}
  </S.Block>
);

export default PremiumBanner;
